import { AGENTS, QUEUES, QUEUE_STATS } from "../types";

const blankAgents = {
  type: "agents",
  agents: [],
  agents_free: [0],
  agents_ringing: [0],
  agents_talking: [0],
  agents_unavailable: [0],
  agents_loggedoff: [0],
  agents_paused: [0],
  agents_pausedtalking: [0],
  agents_pausedunav: [0],
  abandoned_calls: [0],
  timestamp: "",
  sequence: 0,
  agents_available_list: [],
  agents_available_list_in: [],
  agents_available_list_out: [],
  agents_unavailable_list: [],
  agents_aux_list: [],
  callers_inqueue: 0,
  agents_free_in: 0,
  agents_free_out: 0,
  agents_talking_in: 0,
  agents_talking_out: 0,
  agents_ringing_in: 0,
};

const blankQueueStats = {
  type: "queue_stats",
  queue_statistics: [],
  timestamp: "",
  sequence: 0,
  abandoned_count: 0,
};

const blankQueues = {
  type: "queues",
  callers_in_queues: [],
  callers_away: [0],
  callers_ringing: [0],
  callers_inqueue: [0],
  callers_talking: [0],
  callers_abandoned: [0],
  callers_completed: [0],
  longest_waiting_time: [0],
  timestamp: "",
  sequence: 0,
};

const initialState = {
  agents: JSON.parse(sessionStorage.getItem("agents")) || blankAgents,
  queues: JSON.parse(sessionStorage.getItem("queues")) || blankQueues,
  queue_stats:
    JSON.parse(sessionStorage.getItem("queue_stats")) || blankQueueStats,
};

const rmqReducer = (state = initialState, action) => {
  const allowedDepts = sessionStorage.getItem("user")
    ? JSON.parse(sessionStorage.getItem("user")).allowed_depts || []
    : [];

  const allowedQueues = sessionStorage.getItem("user")
    ? JSON.parse(sessionStorage.getItem("user")).allowed_queues || []
    : [];

  let { type, payload } = action;

  switch (type) {
    case AGENTS:
      // Filter agent lists according to the logged-in user's allowed_depts
      payload.agents_available_list_in =
        payload.agents_available_list_in.filter(agent =>
          allowedDepts.includes(agent.dept_id)
        );
      payload.agents_available_list_out =
        payload.agents_available_list_out.filter(agent =>
          allowedDepts.includes(agent.dept_id)
        );
      payload.agents_unavailable_list = payload.agents_unavailable_list.filter(
        agent => allowedDepts.includes(agent.dept_id)
      );
      payload.agents_aux_list = payload.agents_aux_list.filter(agent =>
        allowedDepts.includes(agent.dept_id)
      );

      // Compute status counts for summary display
      payload.agents_free_in = payload.agents_available_list_in.filter(
        agent => agent.status === "Free"
      ).length;
      payload.agents_free_out = payload.agents_available_list_out.filter(
        agent => agent.status === "Free"
      ).length;
      payload.agents_talking_in = payload.agents_available_list_in.filter(
        agent => agent.status === "Talking"
      ).length;
      payload.agents_talking_out = payload.agents_available_list_out.filter(
        agent => agent.status === "Talking"
      ).length;
      payload.agents_ringing_in = payload.agents_available_list_in.filter(
        agent => agent.status === "Ringing"
      ).length;

      return {
        ...state,
        agents: payload,
      };
    case QUEUES:
      // Filter caller list according to the logged-in user's allowed_depts
      payload.callers_in_queues = payload.callers_in_queues.filter(caller =>
        allowedDepts.includes(caller.dept_id) || allowedQueues.includes(caller.system_name)
      );

      return {
        ...state,
        queues: payload,
      };
    case QUEUE_STATS:
      // Filter queues list according to the logged-in user's allowed_depts
      payload.queue_statistics = payload.queue_statistics.filter(queue =>
        allowedDepts.includes(queue.dept_id) || allowedQueues.includes(queue.system_name)
      );
      return {
        ...state,
        queue_stats: payload,
      };
    default:
      return state;
  }
};

export default rmqReducer;
